import {
  NoWhenBranchMatchedException3krrgsc7u48pz as NoWhenBranchMatchedException,
  NullPointerException3mu0rhxjjitqq as NullPointerException,
  ClassCastException1atiay3nqgbd as ClassCastException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from './exceptions.mjs';
import { KotlinNothingValueException2zr0cdstak0a9 as KotlinNothingValueException } from './ExceptionsH.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function noWhenBranchMatchedException() {
  throw NoWhenBranchMatchedException().o5();
}
function THROW_NPE() {
  throw NullPointerException().s5();
}
function THROW_CCE() {
  throw ClassCastException().w5();
}
function throwKotlinNothingValueException() {
  throw KotlinNothingValueException().a4();
}
function THROW_IAE(msg) {
  throw IllegalArgumentException().n2(msg);
}
function ensureNotNull(v) {
  var tmp;
  if (v == null) {
    THROW_NPE();
  } else {
    tmp = v;
  }
  return tmp;
}
//region block: exports
export {
  THROW_CCE as THROW_CCE2g6jy02ryeudk,
  THROW_IAE as THROW_IAE23kobfj9wdoxr,
  ensureNotNull as ensureNotNull1e947j3ixpazm,
  noWhenBranchMatchedException as noWhenBranchMatchedException2a6r7ubxgky5j,
  throwKotlinNothingValueException as throwKotlinNothingValueException2lxmvl03dor6f,
};
//endregion

//# sourceMappingURL=hacks.mjs.map
